// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  TReceiptDetailsGetModel,
  IMappers,
  TReceiptDetailsGetResponse,
  IReceiptDetailsGetResponse,
  IReceiptDetailsGetResponseError,
} from './types';

export const defaultConfig: TReceiptDetailsGetModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'dailyrent',
  pathApi: '/v1/receipt-details/get/',
} as TReceiptDetailsGetModel;

export function createReceiptDetailsGetModel(): TReceiptDetailsGetModel {
  return {
    ...defaultConfig,
  };
}

export interface IReceiptDetailsGetOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchReceiptDetailsGet<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IReceiptDetailsGetOptions<TResponse200, TResponse400>): Promise<
  TReceiptDetailsGetResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createReceiptDetailsGetModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IReceiptDetailsGetResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IReceiptDetailsGetResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TReceiptDetailsGetResponse;
}
